import React from 'react';
import PropTypes from 'prop-types';
import BrowseTileImageContainer from './styled/BrowseTileImageContainer';
import BrowseTileImageText from './styled/BrowseTileImageText';

const BrowseImageTile = ({ url, image, title }) => (
  <a href={url}>
    <BrowseTileImageContainer image={image}>
      <BrowseTileImageText>{title}</BrowseTileImageText>
    </BrowseTileImageContainer>
  </a>
);

BrowseImageTile.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default BrowseImageTile;
